//password eye function
document.addEventListener("DOMContentLoaded", function () {
  const initTogglePassword = (root = document) => {
    root.querySelectorAll(".toggle-password").forEach(function (toggleBtn) {
      if (toggleBtn.dataset.attached === "true") return;
      toggleBtn.dataset.attached = "true";
      
      const wrapper = toggleBtn.closest(".field") || toggleBtn.parentElement;
      const passwordInput = wrapper.querySelector("input[type='password'], input[type='text']");
      const eyeIcon = toggleBtn.querySelector(".eye-icon");
      const eyeFilledIcon = toggleBtn.querySelector(".eye-filled-icon");

      if (!passwordInput || !eyeIcon || !eyeFilledIcon) return;

      toggleBtn.addEventListener("click", function () {
        const isPassword = passwordInput.getAttribute("type") === "password";
        
        // Toggle input type
        passwordInput.setAttribute("type", isPassword ? "text" : "password");

        // Toggle icon visibility
        // If it WAS a password, we are revealing now (text).
        // If revealed -> Show Outline (eyeIcon), Hide Filled (eyeFilledIcon)
        eyeIcon.classList.toggle("hidden", !isPassword);
        eyeFilledIcon.classList.toggle("hidden", isPassword);

        toggleBtn.setAttribute(
          "aria-label",
          isPassword ? "Hide password" : "Show password"
        );
      });
    });
  };

  initTogglePassword(document);
  // Re-init for dynamically loaded content if needed
  document.addEventListener("shopify:section:load", (e) => initTogglePassword(e.target));
});

//register hidden section
document.addEventListener("DOMContentLoaded", function () {
  const continueBtn = document.getElementById("continue-btn");
  const almostDoneSection = document.getElementById("almost-done-section");
  const loginButtons = document.getElementById("login-buttons");

  continueBtn.addEventListener("click", function (e) {
    e.preventDefault();
    loginButtons.classList.add("hidden");
    almostDoneSection.classList.remove("hidden");
  });
});

//password strenght
(function () {
  function initPasswordStrength(root = document) {
    const input = root.querySelector("#CustomerPasswordRegister");
    const barsWrap = root.querySelector("#password-strength-bars");
    const hint = root.querySelector("#password-hint");

    if (!input || !barsWrap || !hint) return;

    const bars = barsWrap.querySelectorAll("[data-bar]");
    const t = hint.dataset;

    function updatePasswordHint(strength) {
      // Show the hint once user starts typing
      hint.classList.remove("hidden");
      const t = hint.dataset;

      if (strength === 0 || strength === 1) {
        hint.textContent = t.passwordRequirements;
      } else if (strength === 2) {
        hint.innerHTML = `${t.passwordStrength}: ${t.weak}`;
      } else if (strength === 3) {
        hint.innerHTML = `${t.passwordStrength}: ${t.good}`;
      } else if (strength === 4) {
        hint.innerHTML = `${t.passwordStrength}: ${t.strong}`;
      }
    }

    function render(strength) {
      // Reset
      bars.forEach((bar) => {
        bar.classList.remove("bar--red", "bar--yellow", "bar--green");
      });

      // Color bars
      for (let i = 0; i < strength; i++) {
        if (strength === 1) bars[i].classList.add("bar--red");
        else if (strength === 2) bars[i].classList.add("bar--yellow");
        else bars[i].classList.add("bar--green");
      }

      // Update hint message
      updatePasswordHint(strength);
    }

    function evaluate(val) {
      const hasLetter = /[A-Za-z]/.test(val);
      const hasNumber = /\d/.test(val);
      const hasSpecial = /[^A-Za-z0-9]/.test(val);
      const len = val.length;

      let strength = 0;

      if (len >= 1 && (!hasLetter || !hasNumber)) {
        strength = 1;
      } else if (hasLetter && hasNumber) {
        if (len < 8) {
          strength = 1;
        } else if (len >= 8 && len <= 10) {
          strength = hasSpecial ? 3 : 2;
        } else if (len > 10 && len <= 14) {
          strength = hasSpecial ? 4 : 3;
        } else if (len > 15) {
          strength = 4;
        }
      }

      render(strength);
    }

    input.addEventListener("input", (e) => evaluate(e.target.value));

    // Run once at load (for autofill)
    evaluate(input.value || "");
  }

  // Fire on normal page load
  document.addEventListener("DOMContentLoaded", () =>
    initPasswordStrength(document)
  );

  // Fire inside Theme Editor preview
  document.addEventListener("shopify:section:load", (e) =>
    initPasswordStrength(e.target)
  );
})();
